import { render, staticRenderFns } from "./DeliveryRoomsCard.vue?vue&type=template&id=6f4bd878"
import script from "./DeliveryRoomsCard.vue?vue&type=script&lang=ts"
export * from "./DeliveryRoomsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports